import get from 'lodash/get';
import { fallBackVideo, fallBackVideo20, fallBackVideo22 } from '../constants';

const createErrorMediaData = error => {
  const { message } = get(error, 'graphQLErrors[0]', error);

  let errorVideoSource;
  let errorVideoTitle;

  switch (true) {
    case message.includes('timeslot_not_eight_pm_until_six_am'):
      errorVideoSource = fallBackVideo20;
      errorVideoTitle =
        'Deze video is alleen te bekijken tussen 20:00 uur en 06:00 uur vanwege een leeftijdsbeperking';
      break;

    case message.includes('timeslot_not_ten_pm_until_six_am'):
      errorVideoSource = fallBackVideo22;
      errorVideoTitle =
        'Deze video is alleen te bekijken tussen 22:00 uur en 06:00 uur vanwege een leeftijdsbeperking';
      break;

    default:
      errorVideoSource = fallBackVideo;
      errorVideoTitle = 'Er is iets fout gegaan met de video.';
      break;
  }

  return {
    play: true,
    isFallback: true,
    title: errorVideoTitle,
    type: 'video',
    source: [
      {
        name: 'HD',
        type: 'video/mp4',
        ratio: '16:9',
        src: errorVideoSource,
      },
    ],
  };
};

export default createErrorMediaData;
